import type {
  MEMBERSHIP_MODELS,
  PLAYER_PORTALS_MODELS,
  SSO_MODELS,
} from '@r-and-a-shared-ui/common-kontent-client';
import {
  getFirstMappedLinkedItemOrDefault,
  getMappedLinkedItems,
} from './utils/component-mapping-helpers';
import {
  getFirstLinkedAssetOrDefault,
  getTrueFalseSingleChoiceValue,
} from '@r-and-a-shared-ui/common-kontent-client/utils';

type FormStepModel = SSO_MODELS.FormStep &
  MEMBERSHIP_MODELS.FormStep &
  PLAYER_PORTALS_MODELS.FormStep;

export const form_step = (data: FormStepModel) => {
  if (!data || !data?.elements) {
    return undefined;
  }

  const { elements } = data;
  const formFields = elements?.form_fields;
  const formCTAs = elements?.ctas;

  return {
    key: data?.system?.codename,
    fieldsData: getMappedLinkedItems(formFields),
    ctasData: getMappedLinkedItems(formCTAs),
    richTextItems: getMappedLinkedItems(elements?.rich_text_items),
    showStepCounter: getTrueFalseSingleChoiceValue(elements?.show_step_counter),
    customHeader: getFirstMappedLinkedItemOrDefault(elements?.custom_header),
    audio: getFirstLinkedAssetOrDefault(elements?.audio),
    displayHideStepBasedOnFieldValue: getFirstMappedLinkedItemOrDefault(
      elements?.display_or_hide_step_based_on_field_value,
    ),
  };
};

export default form_step;
